<script setup lang="tsx">
import type { DocumentReference, URLReference } from '@/models/api-generated'
import CommentField from '../comment_references/CommentField.vue'
import URLReferenceComponent from '../comment_references/URLReference.vue'
import DocumentReferenceComponent from '../comment_references/DocumentReference.vue'

const props = defineProps<{
	canEdit?: boolean
	urlReferences: URLReference[]
	documentReferences: DocumentReference[]
	ownerId: number
	ownerType: string
}>()

const emit = defineEmits<{
	(e: 'update:urlReferences', value: URLReference[]): void
	(e: 'update:documentReferences', value: DocumentReference[]): void
}>()

const model = defineModel<string>({ required: true })
</script>

<template>
	<div class="container-fluid border p-4 rounded w-100 d-flex">
		<slot name="before"></slot>

		<div class="flex-grow-1" :data-test="ownerType + '-comment-' + ownerId">
			<CommentField v-model="model" :label="$t('misc.comment')" :can-edit="props.canEdit" />
		</div>

		<div class="vr mx-3"></div>

		<div :data-test="ownerType + '-url-reference-' + ownerId" class="flex-grow-1">
			<URLReferenceComponent
				:model-value="props.urlReferences"
				@update:model-value="emit('update:urlReferences', $event)"
				:owner-id="props.ownerId"
				:owner-type="props.ownerType"
				:can-edit="props.canEdit"
				:can-add="true"
			/>
		</div>

		<div class="vr mx-3"></div>

		<div :data-test="ownerType + '-document-reference-' + ownerId" class="flex-grow-1">
			<DocumentReferenceComponent
				:model-value="props.documentReferences"
				@update:model-value="emit('update:documentReferences', $event)"
				:owner-id="props.ownerId"
				:owner-type="props.ownerType"
				:can-edit="props.canEdit"
				:can-add="true"
			/>
		</div>

		<slot name="after"></slot>
	</div>
</template>
